import { render, staticRenderFns } from "./ServicesTax.vue?vue&type=template&id=3930dc44&scoped=true&"
import script from "./ServicesTax.vue?vue&type=script&lang=js&"
export * from "./ServicesTax.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTax.vue?vue&type=style&index=0&id=3930dc44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930dc44",
  null
  
)

export default component.exports